export class AttentionLogs {
  constructor(
    public action: string,
    public user: string,
    public userName: string,
    public course: string,
    public material: string,
    public materialName: string,
    public date: Date,
    public time: string
  ) {}
}
